'use strict';

(function () {
    'use strict';

    translationsConfig.$inject = ['$translateProvider'];
    angular.module('app.iot').config(translationsConfig);

    function translationsConfig($translateProvider) {
        'ngInject';

        $translateProvider.translations('el', {
            'timeframe': {
                'name': 'name_el'
            },
            'water': {
                'Water tanks level': 'Στάθμη δεξαμενων υδάτων'
            },
            'iot': {
                'Urban monitoring': 'Αστικό περιβάλλον',
                'Infrastructure management': 'Διαχείριση υποδομής',
                'Analytics historical data': 'Ιστορικά δεδομένα προειδοποιήσεων',
                'Parking management': 'Αισθητήρες αποτροπής στάθμευσης',
                'Humidity': 'Υγρασία',
                'Devices': 'Συσκευή',
                'Wind': 'Άνεμος',
                'Gasses': 'Αέρια',
                'see more': 'περισσότερα',
                'Locations': 'Τοποθεσίες',
                'Modality': 'Μέτρηση',
                'Download': 'Λήψη',
                'Aggregation': 'Ομαδοποίηση τιμών',
                'Dates range': 'Χρονικό διάστημα',
                'Calm': 'Νηνεμία',
                'Date': 'Ημερομηνία',
                'Speed (km/h)': 'Ταχύτητα (Km/h)',
                'Timeframe': 'Χρονικό παράθυρο',
                'Streaming data': 'Δεδομένα πραγματικού χρόνου',
                'Add all': 'Προσθήκη όλων',
                'Remove all': 'Αφαίρεση όλων',
                'Weather conditions': 'Καιρικές συνθήκες',
                'Gasses measurements': 'Μετρήσεις αερίων',

                'Smart City IoT infrastructure': 'Υποδομή του Διαδικτύου των Αντικειμένων',

                'Show out of range measurements': 'Εμφάνιση μετρήσεων εκτός ορίων',
                'Hide out of range measurements': 'Απόκρυψη μετρήσεων εκτός ορίων',

                'Invalid Dates and Aggregation combination': 'Ο αριθμός των μετρήσεων για τον επιλεγμένο συνδυασμό χρονικού διαστήματος και ομαδοποίησης τιμών είναι πολύ μεγάλος για να παρουσιαστεί στο γράφημα. Παρακαλώ εισάγεται ένα μικρότερο χρονικό διάστημα ή επιλέξτε μεγαλύτερη ομάδοποίηση τιμών.',
                'Add more locations': 'Προσθέστε τοπoθεσίες',
                'Urban environment monitoring': 'Παρακολούθηση περιβάλλοντος',
                'Urban environment': 'Αστικό περιβάλλον',
                'Historical data': 'Ιστορικό μετρήσεων',

                'Water environment monitoring': 'Υδάτινο περιβάλλον',
                'Ion measurements': 'Μετρήσεις ιόντων',
                'water conditions': 'Συνθήκες δεξαμενής',

                'warning-disclamer': 'Οι αισθητήρες τελούν υπό βαθμονόμηση. Οι τιμές ενδέχεται να αποκλείνουν από τις πραγματικές.'
            },
            'people': {
                'Crowd Estimation': 'Εκτίμηση Πλήθους',
                'Zone': 'Ζώνη',
                'see more': 'περισσότερα',
                'unit': 'Άνθρωποι'
            },
            'sound': {
                'Sound Levels': 'Επίπεδα θορύβου',
                'Zone': 'Ζώνη',
                'see more': 'περισσότερα'
            },
            'traffic': {
                'Traffic Estimation': 'Εκτίμηση Κίνησης',
                'Station': 'Σταθμός',
                'see more': 'περισσότερα',
                'car': 'Αυτοκίνητο',
                'bus': 'Λεωφορείο',
                'person': 'Πεζός',
                'motorbike': 'Μηχανή',
                'bicycle': 'Ποδήλατο',
                'truck': 'Φορτηγό'
            }
        });
    }
})();